import React from 'react';
import '../users-sales-list/users-sales-list.styles.scss';
import uuid from 'react-uuid';

import SaleFlattened from '../sale/sale-flattened.component';
import SalesTotalChart from '../sales-total-chart/sales-total-chart.component';
import { withRouter } from "react-router-dom";

class ProjectsTotalSalesList extends React.Component {

    handleClick = (sale) => {

    }

    render(){
        const {totalSalesAndCommForProjects, displayStyle} = this.props
        let salesToDisplay = [];
        totalSalesAndCommForProjects.forEach((sale, i) => {
            salesToDisplay.push({
                ...sale,
                number: i + 1,
                projectNameForTotalSales: sale.projectName,
            })
        })

        let fieldToDisplay = {
            number: 'No.',
            projectNameForTotalSales: 'Name',
            totalSales: 'Total Sales',
            totalComm: 'Total Comm',
        };

        let chartFieldToDisplay = {
            number: 'No.',
            projectNameForTotalSales: 'Name',
            totalSales: 'Total Sales',
            barChart: ''
        }

        let barChartLengths = [];
        totalSalesAndCommForProjects.forEach((sale, i)=>{
            barChartLengths[i] = Math.ceil(sale.totalSales / totalSalesAndCommForProjects[0].totalSales * 30);
        })

        return(
                <React.Fragment>
                {salesToDisplay.map((item,i)=>{
                    return(
                        <div key={`sale${i}`} style={{cursor: 'unset'}} className='slc-row'>
                        {
                            {   'Table' : <SaleFlattened key={uuid()} sale={item} i={i} fieldToDisplay={fieldToDisplay} handleClick={this.handleClick}/> ,
                                'Chart' : <SalesTotalChart key={uuid()} sale ={item} n={i} chartFieldToDisplay={chartFieldToDisplay} barChartLengths={barChartLengths} handleClick={this.handleClick} />,
                        }[displayStyle]
                        }
                        </div>
                    )
                })}
                </React.Fragment>
            )   
    }
}

export default withRouter(ProjectsTotalSalesList);

